import React, { useEffect, useState } from 'react';
import { Hero } from '../components/training/Hero.tsx';
import { GrowthPath } from '../components/training/GrowthPath.tsx';
import { WhyChooseUs } from '../components/training/WhyChooseUs.tsx';
import { FlexibleLearning } from '../components/training/FlexibleLearning.tsx';
import { FinalCTA } from '../components/training/FinalCTA.tsx';
import {Footer} from '../components/contact/Footer.tsx';

export function TrainingPage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`training-page ${isLoaded ? 'loaded' : ''}`} style={{ paddingTop: '80px' }}>
      <Hero />
      <GrowthPath />
      <WhyChooseUs />
      <FlexibleLearning />
      <FinalCTA />
      <Footer />
    </div>
  );
}
